<template>
  <div>
    <v-container fluid >
      <v-row no-gutters>
        <v-col cols="12">
          <p class="grey lighten-2 pa-2">
            <span class="font-weight-black ">Descripción:</span>
            <br>
            <span ma-5>
              Este componente permite seleccionar un elemento, en una lista select. <br>
              Se requiere minimo 2 elementos 
            </span>
          </p>
        </v-col> 
        <v-col cols="12">
          <PreguntaControl
            v-model="pregunta"
            :campos="campos"
            :camposIndex="camposIndex" 
          >  
          </PreguntaControl>
        </v-col>
        <v-col cols="12" align-end>
          <span>Obligatorio</span>
          <v-radio-group v-model="obligatorio" row >
            <v-radio
              label="SI"
              value="1"
            ></v-radio>
            <v-radio
              label="NO"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>  
      </v-row>  
      <v-row no-gutters>
        <v-col cols="12">
          <span>Origen de los datos</span>
          <v-radio-group v-model="origenData" row >
            <v-radio
              label="Manual"
              :value="true"
            ></v-radio>
            <v-radio
              label="Tabla"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>  
        <v-col v-if="origenData" cols="12">
          <span>Valores</span>
          <ControlInputVal
            v-model="aValor"
            :noElement="50"
            :campos="campos" 
            :camposIndex="camposIndex">
          ></ControlInputVal>
        </v-col> 
        <v-col v-else cols="12">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="tablaOrigen"
                :items="aTablaOrigen"
                item-text="LabelTabla"
                item-value="idFD_Tabla_Para_Select"
                dense
                filled
                label="Tala Origen"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n9" style="font-size: 12px;" v-if="aTableValor.length > 0">
              <span>Información de muestra (5 primeros registros)</span>
              <div align="center" justify="space-around">
              <v-progress-circular v-if="CargandoTable"
                :size="20"
                color="primary"
                indeterminate
              ></v-progress-circular>
              </div>
              <v-list-item v-for="(Tablevalor, key) in aTableValor.slice(0,5)" :key="key" dense >
                <v-list-item-content>
                  <v-list-item-title  v-text="Tablevalor.id"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title v-text="Tablevalor.valor"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col> 
        <v-col v-if="!origenData" cols="12">
          <span>Modifica A:</span>
          <v-autocomplete
            v-model="modificaA"
            :items="aModificaA"
            item-text="Tabla_secundaria"
            item-value="idFD_Tablas_Para_Select_TS"
            dense
            filled
            label="Tabla a modficia A"
          ></v-autocomplete>
        </v-col> 
      </v-row>  
      <v-row no-gutters>
        <v-col cols="12" align-end v-if="errors.length" style="font-size: 12px;" class="red--text">
          <p >
            <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
            <ul>
              <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
          </p>
        </v-col>  
        <v-col cols="12" align-end>
          <v-btn block color="btncolor" elevation="2" dark @click="Guardar">
           <h2> Guardar </h2>
          </v-btn>
        </v-col> 
      </v-row>  
    </v-container>   
  </div>
</template>

<script>
import axiosServices from '@/services/axiosServices.js'
import ControlInputVal from '@/components/dragdrop/Campos/ControlInputVal.vue'
import { mapGetters } from 'vuex'
import PreguntaControl from '@/components/dragdrop/Campos/PreguntaControl.vue'


export default {
  name:"SelectConfig",
  components: {
    ControlInputVal,
    PreguntaControl,
  },
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    }, 
  },
  data() {
    return {
      pregunta  : '',
      obligatorio : '',
      aPreguntas : [],
      errors : [],
      aValor : [],
      aTableValor : [],
      origenData : '',     // true es manual
      tablaOrigen : '',
      aTablaOrigen : [],
      modificaA : '',
      aModificaA : [],
      CargandoTable : false,
    }
  },
  mounted () {
    this.getCaposSelect()
    this.cargarDatos()
  },
  methods: {
    async getCaposSelect() {
      const axiosPreguntas = await axiosServices.getConfiguration('buildDinamicos/preguntas', true )
      this.aPreguntas = axiosPreguntas.aData

      this.getTablas()

    },
    validarInfo(){

      this.errors = []

      if(this.pregunta == '' || this.pregunta == null || this.pregunta == 'undefined' ){
       this.errors.push('Debe Seleccionar una pregunta!')
      }
      if(this.obligatorio == ''){
       this.errors.push('Debe indicar si es obligatorio!')
      }

      // valido si la pregunta no esta repetida
      const auxboard = this.$store.state.board.columns[1].campos
      const preguntaIndex = auxboard.findIndex(campo =>
        ( campo.idPregunta == this.pregunta && campo.NombreTipo != "Grupo" && campo.NombreTipo !="Item")
      )

      if(preguntaIndex != this.camposIndex && preguntaIndex > -1){
       this.errors.push('La pregunta seleccionada esta en otro campo, No la puede emplear!')
      }

      if(this.origenData && this.aValor.length == 0){
       this.errors.push('Debe contar con dos registro de Valores mínimo!')
      }
      if(this.origenData && this.aValor.length < 2){
       this.errors.push('El número de registros de Valores deber ser 2 Minimo!')
      }

      if(!this.origenData && this.aTableValor.length == 0){
       this.errors.push('La tabla seleccionada no cuenta con información!. Hable con el Administardor')
      }
      if(!this.origenData && this.aTableValor.length < 2){
       this.errors.push('El número de registros de Valores deber ser 2 Minimo!. Hable con el Administardor')
      }

      // valido que si modifica esta activo solo un select puede modificar a otro
      // para esto valido que solo este sede en uno de los select recorro lo que tengo guardado

      const auxBoard = this.getsboard.columns[1].campos.filter(elemento => elemento.NombreTipo == 'Select')
      let contador = 0
      auxBoard.forEach( element => {
        if( element['modificaA'] != undefined && element.modificaA.length > 0 ){
          contador = element.modificaA[0].idFD_Tablas_Para_Select_TS == this.modificaA ? contador + 1 : contador
        }
      })

      if(contador > 1 ){
        this.errors.push('Hay otro select modificando a la tabla seleccionada. Por favor corregir este punto')
      }


      if( this.errors.length==0 ){
        return false 
      } else {
        return true 
      }

    },
    Guardar(){

      if( this.validarInfo() ){
        return
      }

      const auxPregunta = this.aPreguntas.filter( preguntas => preguntas.idFD_Pregunta == this.pregunta )
      const auxMoificaA = this.aModificaA.filter( modifica => modifica.idFD_Tablas_Para_Select_TS == this.modificaA)

      const auxcampo = {
          id : this.campos.id,
          ancho : this.campos.ancho,
          userAssigned : this.campos.userAssigned,
          idTipoCampo : this.campos.idTipoCampo,
          NombreTipo : this.campos.NombreTipo,
          name : this.campos.name,
          idPregunta : this.pregunta ,
          pregunta : auxPregunta[0].Pregunta,
          obligatorio : this.obligatorio,
          origenData : this.origenData ,
          tablaOrigen : this.tablaOrigen, 
          modificaA : auxMoificaA,
          valor : (this.origenData ? this.aValor : this.aTableValor)

      }

      this.$store.dispatch('salvarCampoBoard',{camposIndex:this.camposIndex, campo:auxcampo })

    },
    cargarDatos() {
      this.errors = []
      this.aValor = []
      this.aTableValor = [] 
      this.aModificaA = []


      this.pregunta = this.campos.idPregunta == 0 ? 0 : this.campos.idPregunta
      this.obligatorio = this.campos.obligatorio
      this.origenData  = this.campos.origenData

      this.aValor = this.campos.origenData ?  this.campos.valor : []
     
      this.aTableValor = !this.campos.origenData ? this.campos.valor : []
      this.tablaOrigen = !this.campos.origenData ? this.campos.tablaOrigen : '' 

      this.modificaA   = this.campos['modificaA'] != undefined && this.campos.modificaA.length > 0 ? this.campos.modificaA[0].idFD_Tablas_Para_Select_TS : []


      this.getModificaA()

    },
    async getModificaA() {
      // primero traigotodos los campos segun la tabla seccionada
      const oTable = this.aTablaOrigen.filter( TableSelect => TableSelect.idFD_Tabla_Para_Select == this.tablaOrigen )[0]

      if(oTable != undefined){
        const sParams = `TableName=${oTable.NombreTabla}`

        let auxModificaA = await axiosServices.getConfiguration('buildDinamicos/select_modificaA', true, sParams)
        auxModificaA = auxModificaA.aData

        // tengo que revisar si existe un select de la tabla que exiten y saco los select 
        const auxBoard = this.getsboard.columns[1].campos.filter(elemento => elemento.NombreTipo == 'Select')

        this.aModificaA = []
        auxBoard.forEach(campo => {
          if((!campo.origenData)){
            auxModificaA.forEach(modificaA => {
              if(campo.tablaOrigen !== undefined && ( modificaA.idFD_Tablas_Para_Select_TS == campo.tablaOrigen ) ){
                this.aModificaA.push(modificaA)
              }
            })
          }
        })

      } else {
        return []
      }
    },
    async getTablas() {
      this.CargandoTable = true
      const axiosTablas = await axiosServices.getConfiguration('buildDinamicos/select_tablas', true )
      this.aTablaOrigen = axiosTablas.aData
      this.CargandoTable = false
    }
  },
  computed: {

    ...mapGetters(['getsboard'])

  },
  watch: {
    camposIndex(newValue, oldValue) {
      if (newValue !== oldValue){
        this.getCaposSelect()
        this.cargarDatos()
      }
    },
    async tablaOrigen(newValue){
      
      if(newValue != undefined ){
        await this.getTablas()
      }

      const oTable = this.aTablaOrigen.filter( TableSelect => TableSelect.idFD_Tabla_Para_Select == newValue )[0]
      
      if(oTable != undefined){
          const sParams = `TableName=${oTable.NombreTabla}&Primarykey=${oTable.Primaria}&Valor=${oTable.Loockup}`

          this.CargandoTable = true
          const axiosValueTable = await axiosServices.getConfiguration('buildDinamicos/select_tablas_info', true, sParams  )
          this.aTableValor = Object.keys(axiosValueTable.aData ).length > 0 ?  axiosValueTable.aData : []
          this.CargandoTable = false
       }

        this.getModificaA()

    },
    origenData(newValue){
      if( newValue ){
        this.aValor = (newValue == this.campos.origenData) ? this.campos.aValor : []
        this.tablaOrigen= ''  // lo borro para volvelo a cargar 

      } else {
        this.aTableValor = []
        this.tablaOrigen = (newValue == this.campos.origenData) ? this.campos.tablaOrigen : ''
        this.aModificaA = []
      }
    },
    pregunta(){
      this.getCaposSelect()
    }
  },
}
</script>

<style lang="scss" scoped>

</style>